/**
 * @generated SignedSource<<ffddf496dd64b54266b232c2aeff8158>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "where"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssetTablePanel_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "where",
                    "variableName": "where"
                }
            ],
            "kind": "FragmentSpread",
            "name": "AssetTable_query"
        }
    ],
    "type": "Query",
    "abstractKey": null
};
node.hash = "1c718023b53d49a1cd4fc3452de6e82a";
export default node;
